import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/images/label/triad.gif'


const _hoisted_1 = { class: "d-flex flex-column mx-3" }
const _hoisted_2 = { class: "d-flex flex-row" }
const _hoisted_3 = { class: "d-flex ml-auto p-2 gap-2" }
const _hoisted_4 = {
  class: /*#__PURE__*/_normalizeClass({ 'row': true, 'g-3': true, 'px-3': true, 'pt-3': true })
}
const _hoisted_5 = ["for"]
const _hoisted_6 = ["for"]
const _hoisted_7 = ["for"]
const _hoisted_8 = { class: "d-flex flex-row" }
const _hoisted_9 = ["title"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["for"]
const _hoisted_13 = ["for"]
const _hoisted_14 = { class: "d-flex flex-row" }
const _hoisted_15 = ["id"]
const _hoisted_16 = ["title"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-export-to-pdf" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["for"]
const _hoisted_20 = { class: "d-flex flex-row" }
const _hoisted_21 = ["id"]
const _hoisted_22 = ["title"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-download" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  class: "triadSize",
  src: _imports_0
}, null, -1)
const _hoisted_26 = { class: "d-flex flex-row" }
const _hoisted_27 = { class: "d-flex flex-row" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-add" }, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "d-flex flex-row" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-add" }, null, -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { class: "d-flex flex-row" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "ci ci-add" }, null, -1)
const _hoisted_35 = [
  _hoisted_34
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_FormGridMember = _resolveComponent("FormGridMember")!
  const _component_CustomSelect = _resolveComponent("CustomSelect")!
  const _component_Select = _resolveComponent("Select")!
  const _component_FormGridColumn = _resolveComponent("FormGridColumn")!
  const _component_CheckBox = _resolveComponent("CheckBox")!
  const _component_FormGridLocal = _resolveComponent("FormGridLocal")!
  const _component_LabelTextFieldListWidget = _resolveComponent("LabelTextFieldListWidget")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t("review.labelContent.edit.caption", { label : this.label.name })), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.saveAndExit()), ["prevent"]))
        }, _toDisplayString(_ctx.$t('general.save')), 1),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => {this.$router.back();})
        }, _toDisplayString(_ctx.$t('general.cancel')), 1)
      ])
    ]),
    _createVNode(_component_FormGridLocal, {
      columns: 2,
      labelWidth: 12
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_FormGridColumn, null, {
            default: _withCtx(() => [
              _createVNode(_component_FormGridMember, null, {
                label: _withCtx(({ controlId, class: clazz }) => [
                  _createElementVNode("label", {
                    class: _normalizeClass(`col-form-label text-md-end ${clazz}`),
                    for: controlId
                  }, _toDisplayString(_ctx.$t('general.name')), 11, _hoisted_5)
                ]),
                control: _withCtx(({ id }) => [
                  _createVNode(_component_TextInput, {
                    id: id,
                    modelValue: this.labelContent.name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.labelContent.name) = $event)),
                    maxlength: "255"
                  }, null, 8, ["id", "modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_FormGridMember, null, {
                label: _withCtx(({ controlId, class: clazz }) => [
                  _createElementVNode("label", {
                    class: _normalizeClass(`col-form-label text-md-end ${clazz}`),
                    for: controlId
                  }, _toDisplayString(_ctx.$t('review.labelContent.edit.primaryReviewCycle')), 11, _hoisted_6)
                ]),
                control: _withCtx(({ id }) => [
                  _createVNode(_component_TextInput, {
                    id: id,
                    disabled: true,
                    modelValue: this.reviewCycleName
                  }, null, 8, ["id", "modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_FormGridMember, null, {
                label: _withCtx(({ controlId, class: clazz }) => [
                  _createElementVNode("label", {
                    class: _normalizeClass(`col-form-label text-md-end ${clazz}`),
                    for: controlId
                  }, _toDisplayString(_ctx.$t('review.labelContent.edit.alternativeReviewCycle')), 11, _hoisted_7)
                ]),
                control: _withCtx(({ id }) => [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_CustomSelect, {
                      class: "flex-grow-1 alternativeReviewCycle",
                      id: id,
                      optional: "",
                      optionalLabel: _ctx.$t('general.none'),
                      options: this.reviewCycleOptions,
                      modelValue: this.alternativeReviewCycleId,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((this.alternativeReviewCycleId) = $event))
                    }, null, 8, ["id", "optionalLabel", "options", "modelValue"]),
                    (this.alternativeReviewCycleId != null)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-sm btn-outline-primary ms-2",
                          onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.copySelectedTextFields && _ctx.copySelectedTextFields(...args)), ["prevent"])),
                          title: _ctx.$t('review.labelContent.edit.copySelectedTextFields')
                        }, _hoisted_11, 8, _hoisted_9))
                      : _createCommentVNode("", true),
                    (this.alternativeReviewCycleId != null)
                      ? (_openBlock(), _createBlock(_component_CustomSelect, {
                          key: 1,
                          class: "flex-grow-1 selectedSourceReviewCycle ms-2",
                          id: id,
                          optional: "",
                          optionalLabel: _ctx.$t('general.none'),
                          options: this.reviewCycleOptions,
                          modelValue: this.selectedSourceReviewCycleId,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((this.selectedSourceReviewCycleId) = $event))
                        }, null, 8, ["id", "optionalLabel", "options", "modelValue"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_FormGridMember, null, {
                label: _withCtx(({ controlId, class: clazz }) => [
                  _createElementVNode("label", {
                    class: _normalizeClass(`col-form-label text-md-end ${clazz}`),
                    for: controlId
                  }, _toDisplayString(_ctx.$t('review.labelContent.edit.rotation')), 11, _hoisted_12)
                ]),
                control: _withCtx(({ id }) => [
                  _createVNode(_component_Select, {
                    id: id,
                    options: this.rotationOptions,
                    modelValue: this.labelContent.rotationAngle,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((this.labelContent.rotationAngle) = $event))
                  }, null, 8, ["id", "options", "modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_FormGridMember, null, {
                label: _withCtx(({ controlId, class: clazz }) => [
                  _createElementVNode("label", {
                    class: _normalizeClass(`col-form-label text-md-end ${clazz}`),
                    for: controlId
                  }, _toDisplayString(_ctx.$t('review.labelContent.edit.hpgl')), 11, _hoisted_13)
                ]),
                control: _withCtx(({ id }) => [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("input", {
                      id: id,
                      type: "file",
                      onChange: _cache[7] || (_cache[7] = ($event: any) => {this.pdfFile = ($event.target.files[0] ?? null);})
                    }, null, 40, _hoisted_15),
                    (this.labelContent.filename != null)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-sm",
                          "data-bs-toggle": "tooltip",
                          title: _ctx.$t('review.labelContent.list.previewToolTip'),
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openPreview()))
                        }, _hoisted_18, 8, _hoisted_16))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_FormGridMember, null, {
                label: _withCtx(({ controlId, class: clazz }) => [
                  _createElementVNode("label", {
                    class: _normalizeClass(`col-form-label text-md-end ${clazz}`),
                    for: controlId
                  }, _toDisplayString(_ctx.$t('review.labelContent.edit.original')), 11, _hoisted_19)
                ]),
                control: _withCtx(({ id }) => [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("input", {
                      id: id,
                      type: "file",
                      onChange: _cache[9] || (_cache[9] = ($event: any) => {this.originalFile = ($event.target.files[0] ?? null);})
                    }, null, 40, _hoisted_21),
                    (this.labelContent.origFilename != null)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-sm",
                          "data-bs-toggle": "tooltip",
                          title: _ctx.$t('review.labelContent.list.downloadToolTip'),
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.download()))
                        }, _hoisted_24, 8, _hoisted_22))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              _hoisted_25
            ]),
            _: 1
          }),
          _createVNode(_component_FormGridColumn, null, {
            default: _withCtx(() => [
              _createVNode(_component_CheckBox, {
                id: _ctx.id,
                modelValue: this.labelContent.isRenderableOutside,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((this.labelContent.isRenderableOutside) = $event)),
                label: _ctx.$t('review.labelContent.edit.renderableOutsideLabel'),
                title: _ctx.$t('review.labelContent.edit.renderableOutsideToolTip')
              }, null, 8, ["id", "modelValue", "label", "title"]),
              _createVNode(_component_CheckBox, {
                id: _ctx.id,
                modelValue: this.labelContent.isDefault,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((this.labelContent.isDefault) = $event)),
                label: _ctx.$t('review.labelContent.edit.defaultLabel')
              }, null, 8, ["id", "modelValue", "label"]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.openLabelContentPreviewWindow()), ["prevent"]))
                }, _toDisplayString(this.$t("review.upload.preview.preview")), 1)
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("h3", null, _toDisplayString(this.$t("review.labelContent.edit.signatureCaption")), 1),
      _createElementVNode("button", {
        class: "btn ms-3 mb-2",
        onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.addSignatureTextField()), ["prevent"]))
      }, _hoisted_29)
    ]),
    _createVNode(_component_LabelTextFieldListWidget, {
      items: this.signatureFields,
      fieldType: "SIGNATURE",
      labelContentInfo: this.labelContentInfo,
      alternativeReviewCycleId: this.alternativeReviewCycleId,
      selectedSourceReviewCycleId: this.selectedSourceReviewCycleId,
      onRemoveTextField: _ctx.removeTextField
    }, null, 8, ["items", "labelContentInfo", "alternativeReviewCycleId", "selectedSourceReviewCycleId", "onRemoveTextField"]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("h3", null, _toDisplayString(this.$t("review.labelContent.edit.documentVersionCaption")), 1),
      _createElementVNode("button", {
        class: "btn ms-3 mb-2",
        onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.addDocumentVersionTextField()), ["prevent"]))
      }, _hoisted_32)
    ]),
    _createVNode(_component_LabelTextFieldListWidget, {
      items: this.documentVersionFields,
      fieldType: "DOCUMENT_VERSION",
      labelContentInfo: this.labelContentInfo,
      alternativeReviewCycleId: this.alternativeReviewCycleId,
      selectedSourceReviewCycleId: this.selectedSourceReviewCycleId,
      onRemoveTextField: _ctx.removeTextField
    }, null, 8, ["items", "labelContentInfo", "alternativeReviewCycleId", "selectedSourceReviewCycleId", "onRemoveTextField"]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("h3", null, _toDisplayString(this.$t("review.labelContent.edit.freeTextCaption")), 1),
      _createElementVNode("button", {
        class: "btn ms-3 mb-2",
        onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.addFreeTextField()), ["prevent"]))
      }, _hoisted_35)
    ]),
    _createVNode(_component_LabelTextFieldListWidget, {
      items: this.freeFields,
      fieldType: "FREE",
      labelContentInfo: this.labelContentInfo,
      alternativeReviewCycleId: this.alternativeReviewCycleId,
      selectedSourceReviewCycleId: this.selectedSourceReviewCycleId,
      onRemoveTextField: _ctx.removeTextField
    }, null, 8, ["items", "labelContentInfo", "alternativeReviewCycleId", "selectedSourceReviewCycleId", "onRemoveTextField"])
  ]))
}